export function handleCoreServicesItemHeight() {
    const coreServiceItems = document.querySelectorAll('.aegis-core-service-item');
	if (!coreServiceItems) {
		return;
	}
	coreServiceItems.forEach(coreServiceItem => {
		const imgContainer: HTMLElement = coreServiceItem.querySelector('.aegis-core-service-image');
		const imgSubContainer:HTMLElement = coreServiceItem.querySelector('.elementor-widget-container');
		imgContainer.style.height = `unset`;
		const imgSubContainerHeight = parseFloat(window.getComputedStyle(imgSubContainer).getPropertyValue("height")).toFixed(2);
		imgContainer.style.height = `${imgSubContainerHeight}px`;
	})
	window.addEventListener("resize", handleResize);
	function handleResize() {
		coreServiceItems.forEach(coreServiceItem => {
			const imgContainer: HTMLElement = coreServiceItem.querySelector('.aegis-core-service-image');
			const imgSubContainer:HTMLElement = coreServiceItem.querySelector('.elementor-widget-container');
			imgContainer.style.height = `unset`;
			const imgSubContainerHeight = parseFloat(window.getComputedStyle(imgSubContainer).getPropertyValue("height")).toFixed(2);
			imgContainer.style.height = `${imgSubContainerHeight}px`;
		})
	}
}